import React from 'react';

const Yetkisiz = () => {
    return (
        <div>
            <section className="bg-white lg:min-h-[calc(100vh_-_64px)]">
                <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
                    <div className="mx-auto max-w-screen-sm text-center">
                        <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-slate-600">403</h1>
                        <p className="mb-4 text-3xl tracking-tight font-bold text-red-600 md:text-4xl ">Uyarı!</p>
                        <p className="mb-4 text-lg font-light text-gray-500 ">Üzgünüz, yetkiniz olmayan bir sayfaya erişmeye çalışıyorsunuz</p>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Yetkisiz;
